import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageParams } from './page-params.model';

@Injectable()
export abstract class PageParamsAdapter {
  abstract setPageParams(pageParams: Partial<PageParams>): void;
  abstract getPageParams(): Observable<PageParams>;
}
